export const constants = {
  GET_INTEGRATION: 'GET_INTEGRATION',
  ADD_MULTI_WITH_INTEGRATION: 'ADD_MULTI_WITH_INTEGRATION',
};
